/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GroupDefs from './defs.defs'

const $nsid = 'chat.bsky.group.editJoinLink'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  convoId: /*#__PURE__*/ l.string(),
  joinRule: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<GroupDefs.JoinRule>((() => GroupDefs.joinRule) as any),
  ),
  requireApproval: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  joinLink: /*#__PURE__*/ l.ref<GroupDefs.JoinLinkView>(
    (() => GroupDefs.joinLinkView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Edits the existing join link settings for the group convo. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidConvo',
  'InsufficientRole',
  'NoJoinLink',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
